import { Link } from "react-router-dom";

const Page404 = () => {
  return <div className="page-404 bg-primary-4 h-screen overflow-hidden justify-center items-center flex flex-col max-sm:hidden w-full max-w-screen overflow-x-hidden gap-5">
    <h1 className="text-4xl font-extrabold">404 Page Not Found</h1>
    <p className="text-lg italic">Sorry, the page you are looking for does not exist.</p>
    <Link className="text-primary-6 hover:underline hover:text-primary-3 p-4" to={"/"}>Go Back To home</Link>
  </div>;
};
export default Page404;